var Artistes_List = {

	isMoving:false,
	mouseX:0,
	mouseY:0,
	currentRoll:null,
	timeoutRoll:0,

	init:function(){
		if(Config.isTouchDevice()){
			$(".rollover-container").addClass("mobile");
		}

		$('.tease-artiste').mousemove(function(event){            
			Artistes_List.mouseX = event.pageX - $(this).offset().left;
			Artistes_List.mouseY = event.pageY - $(this).offset().top;
		});


		$(".tease-artiste").find(".illustration").mouseenter(function(){

			Artistes_List.currentRoll = $(this).find(".rollover-container");
			

			clearTimeout(Artistes_List.timeoutRoll);
			Artistes_List.timeoutRoll = setTimeout(function(){
				Artistes_List.currentRoll.addClass("visible");
			}, 80);


			Artistes_List.isMoving = true;
			Artistes_List.moveRollover();
			
		}).mouseleave(function(){
			Artistes_List.isMoving = false;
			clearTimeout(Artistes_List.timeoutRoll);
			/*$(this).find("img").css({width:$(this).find("img").attr("out_w"), height:$(this).find("img").attr("out_h")});*/
			$(this).find(".rollover-container").removeClass("visible");
		});
	},
	moveRollover:function(){

		Artistes_List.currentRoll.css({left:Artistes_List.mouseX, top:Artistes_List.mouseY});

		if(Artistes_List.isMoving == true){
			setTimeout(function(){
				Artistes_List.moveRollover();
			}, 40);
		}
	}
}

$(window).load(function(){
	if($(".tease-artiste").length){
		Artistes_List.init();
	}
})